import gql from 'graphql-tag';

export const UNLINK_AFTERMARKET_PRODUCT = gql`
  mutation UnlinkAftermarketProduct($input: UnlinkAftermarketProductInput!) {
    unlinkAftermarketProduct(input: $input) {
      aftermarketProductId
      partnerLinkId
      success
      errorMessage
    }
  }
`;
